import React, { useMemo, useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { TimelineOutlined } from '@mui/icons-material';

import EmptyState from '../../common/EmptyState';
import ProfileTimeline, { EVENT_KIND_LABEL } from './ProfileTimeline';
import { ProfileEvent, ProfileEventKind } from './profileEvents';

/** Everything that has happened to this person, filterable by kind. */
const StudentTimelineTab: React.FC<{ events: ProfileEvent[] }> = ({ events }) => {
  const [kind, setKind] = useState<ProfileEventKind | 'all'>('all');

  // Only offer the kinds this person actually has.
  const kinds = useMemo(
    () => (Object.keys(EVENT_KIND_LABEL) as ProfileEventKind[]).filter(k => events.some(e => e.kind === k)),
    [events],
  );
  const shown = useMemo(() => (kind === 'all' ? events : events.filter(e => e.kind === kind)), [events, kind]);

  if (events.length === 0) {
    return (
      <EmptyState
        icon={<TimelineOutlined />}
        title="Nothing recorded yet"
        description="Admissions, enrollments, fees and letters appear here as they happen."
        dense
      />
    );
  }

  return (
    <Stack spacing={2.5}>
      {kinds.length > 1 && (
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', rowGap: 1 }}>
          {(['all', ...kinds] as const).map(k => (
            <Chip
              key={k}
              label={k === 'all' ? 'All' : EVENT_KIND_LABEL[k]}
              size="small"
              color={kind === k ? 'primary' : 'default'}
              variant={kind === k ? 'filled' : 'outlined'}
              onClick={() => setKind(k)}
              sx={{ fontWeight: 500 }}
            />
          ))}
        </Stack>
      )}
      <ProfileTimeline events={shown} />
    </Stack>
  );
};

export default StudentTimelineTab;
